import { render, staticRenderFns } from "./LinkTermsText.vue?vue&type=template&id=06a71ebe&scoped=true"
import script from "./LinkTermsText.vue?vue&type=script&lang=js"
export * from "./LinkTermsText.vue?vue&type=script&lang=js"
import style0 from "./LinkTermsText.vue?vue&type=style&index=0&id=06a71ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a71ebe",
  null
  
)

export default component.exports